/** 风格转换工具 */
export default class StyleTransform {
  static isObject(o) {
    return typeof o === "object" && o !== null;
  }

  static camelCaseToSnakeCase(s) {
    return s
      .replace(/([A-Z][a-z])/g, (m, p1) => `_${p1.toLowerCase()}`)
      .replace(/([a-z])([A-Z])$/g, (m, p1, p2) => `${p1}_${p2.toLowerCase()}`)
      .replace(/([a-z])([A-Z]{2,})$/g, (m, p1, p2) => `${p1}_${p2}`)
      .replace(/^_/, "");
  }

  static snakeCaseToCamelCase(s) {
    return s.replace(/(_\w)/g, (m) => m[1].toUpperCase());
  }

  /**
   * 对象key值转换为驼峰格式
   * @param {*} o
   * @returns
   */
  static convertKeysToCamelCase(o) {
    if (Array.isArray(o)) {
      // 如果数组元素是简单类型的则默认不需要遍历
      if (o.length > 0 && !Array.isArray(o[0]) && !this.isObject(o[0])) {
        return o;
      }
      return o.map((item) => StyleTransform.convertKeysToCamelCase(item));
    }
    if (this.isObject(o)) {
      const result = {};
      Object.keys(o).forEach((key) => {
        result[
          StyleTransform.snakeCaseToCamelCase(key)
        ] = StyleTransform.convertKeysToCamelCase(o[key]);
      });
      return result;
    }
    return o;
  }

  /**
   * 对象key值转换为蛇形格式
   * @param {*} o
   * @returns
   */
  static convertKeysToSnakeCase(o) {
    if (Array.isArray(o)) {
      // 如果数组元素是简单类型的则默认不需要遍历
      if (o.length > 0 && !Array.isArray(o[0]) && !this.isObject(o[0])) {
        return o;
      }
      return o.map((item) => StyleTransform.convertKeysToSnakeCase(item));
    }
    if (this.isObject(o)) {
      const result = {};
      Object.keys(o).forEach((key) => {
        result[
          StyleTransform.camelCaseToSnakeCase(key)
        ] = StyleTransform.convertKeysToSnakeCase(o[key]);
      });
      return result;
    }
    return o;
  }
}
